<div class="documentsList" [class.m-x-sm]="!hideTitle" *ngIf="!isMobile">
  <form (keydown.enter)="$event.preventDefault()" [formGroup]="filterForm">
    <div class="box-header" [ngClass]="hideTitle ? 'flex-end' : 'flex-between align-items-center'">
      <h3 *ngIf="!hideTitle">{{ 'DOCUMENTS.employee_documents' | translate }}</h3>
      <div class="header-actions">
        <button (click)="clearAllFilters()"
                [disabled]="!isFiltering()"
                class="btn btn-sm btn-plain-primary l-h m-a-0 m-r-xs m-l-xs"
                test-id="btnCleanFilters">
          {{ 'COMMON.clearFilters' | translate }}
        </button>
        <span
          *ngIf="!isESS"
          container="body"
          [tooltip]="!isDocumentCreationAllowed && !loading ? ('DOCUMENTS.upload_limit_reached' | translate) : ''"
          placement="bottom">
          <button (click)="openUploadDocumentModal()"
                  [disabled]="readonly || !isDocumentCreationAllowed"
                  [ngClass]="{'pointer-none': !isDocumentCreationAllowed}"
                  class="btn btn-outline-primary btn-sm m-l-xs"
                  test-id="btnUpload">
            <em class="fa fa-light fa-upload"></em>
            {{ 'COMMON.upload' | translate }}
          </button>
        </span>
        <span [tooltip]="!isDocumentCreationAllowed && !loading? ('DOCUMENTS.generate_limit_reached' | translate) : ''"
              placement="bottom">
          <button (click)="openGenerateDocumentModal()"
                  *ngIf="!isESS"
                  [disabled]="readonly || !isDocumentCreationAllowed"
                  [ngClass]="{'pointer-none': !isDocumentCreationAllowed}"
                  class="btn btn-primary btn-sm m-l-xs"
                  test-id="btnNewDocument">
          <em class="fa fa-light fa-plus-circle"></em>
            {{ 'DOCUMENTS.new_document' | translate }}
        </button>
        </span>
      </div>
    </div>
    <div class="box-body">
      <table aria-describedby="documentsList" class="table table-striped gp-table documentsList">
        <thead class="table-header-sticky-top">
        <tr role="row">
          <th class="text-uppercase text-sm p-y-0 w-310"
              scope="col"
              test-id="templateName-header">
            {{ 'DOCUMENTS.document_title' | translate }}
          </th>
          <th class="text-uppercase text-sm p-y-0 w-310"
              scope="col"
              test-id="file-header">
            {{ 'TEMPLATE.templateName' | translate }}
          </th>
          <th class="text-uppercase text-sm p-y-0 w"
              scope="col"
              test-id="createdBY-header">
            {{ 'TEMPLATE.created_by' | translate }}
          </th>
          <th class="text-uppercase text-sm p-y-0 w"
              scope="col"
              test-id="creationDate-header">
            {{ 'LEGAL_REPORTS.creationDate' | translate }}
          </th>
          <th class="text-uppercase text-sm p-y-0 w"
              *ngIf="!isESS"
              scope="col"
              test-id="status-header">
            {{ 'DOCUMENTS.employee_space' | translate }}
          </th>
          <th class="text-uppercase text-sm p-y-0 w"
              *ngIf="!isESS && signatureEnabled"
              scope="col"
              test-id="signature-header">
            {{ 'DOCUMENTS.signature' | translate }}
          </th>
          <th class="p-y-0 w-50" scope="col"></th>
        </tr>
        <tr role="row">
          <td class="p-y-0 w-310">
            <input [attr.test-id]="'documentSearchByName'"
                   class="form-control"
                   formControlName="name"
                   id="name"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text">
          </td>
          <td class="p-y-0 w-310">
            <input [attr.test-id]="'documentSearchByTemplate'"
                   class="form-control"
                   formControlName="template"
                   id="template"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text">
          </td>
          <td class="p-y-0 w">
            <input [attr.test-id]="'documentSearchByCreator'"
                   class="form-control"
                   formControlName="creator"
                   gpClearCharactersInput
                   id="creator"
                   placeholder="{{ 'NAVBAR.search' | translate }} ..."
                   type="text">
          </td>
          <td class="p-y-0 w">
            <datepicker-input [hasEternity]="true"
                              [isAppendToBody]="true"
                              formControlName="date"
                              ngDefaultControl>
            </datepicker-input>
          </td>
          <td class="p-y-0 w-sm" *ngIf="!isESS">
            <gp-tree-multi-select #statusFilterComponent
                                  (selectedChange)="onStatusSelected($event)"
                                  *ngIf="statusTree.length"
                                  [attr.test-id]="'status-select' | gpTestId: 'documents'"
                                  [config]="treeConfig"
                                  [isSorted]="true"
                                  [items]="statusTree">
            </gp-tree-multi-select>
          </td>
          <td class="p-y-0 w" *ngIf="!isESS && signatureEnabled">
            <gp-tree-multi-select #signatureStatusFilterComponent
                                  (selectedChange)="onSignatureStatusSelected($event)"
                                  *ngIf="signatureStatusTree.length"
                                  [attr.test-id]="'signature-status-select' | gpTestId: 'documents'"
                                  [config]="treeConfig"
                                  [isSorted]="true"
                                  [items]="signatureStatusTree">
            </gp-tree-multi-select>
          </td>
          <td class="w-50"></td>
        </tr>
        </thead>
        <tbody class="fade-in-right">
        <tr *ngIf="loading">
          <td class="text-center p-t-lg p-b-lg" [attr.colspan]="isESS ? 5 : (signatureEnabled ? 7 : 6)">
            <em class="fa fa-light fa-spinner fa-spin"></em>
          </td>
        </tr>
        <ng-container *ngIf="!loading && documents?.length">
          <tr (click)="onDocumentSelect(document, $event)"
              *ngFor="let document of documents; trackBy: trackByDocumentId"
              [ngClass]="{'pointer': !readonly}"
              class="document-row">
            <td class="w-310" test-id="document-file">
              <span [innerHTML]="document?.name | gpDisplayFile: true" class="text-ellipsis w-310"></span>
            </td>
            <td class="wrap w-310" test-id="document-templateName">
              <span [class.font-italic]="document.family === UPLOADED_DOCUMENT">
                {{ (document.family === UPLOADED_DOCUMENT ? 'DOCUMENTS.UPLOADED_DOCUMENT' : document?.family) | translate }}</span>
            </td>
            <td class="w" test-id="document-createdBy">
              <div class="flex">
                <span [attr.test-id]="'document-createdBy-fullName'">
                  {{ document?.tags?.creator }}
                </span>
              </div>
            </td>
            <td class="w"
                test-id="document-creationDate">{{ document?.creationDate | gpDate: {withHour: true} : (trigger$|async) }}
            </td>
            <td class="w-sm" test-id="document-status" *ngIf="!isESS">
              <div [ngClass]="isPublished(document) ? 'status-published' : 'status-not-published'"
                   class="status text-center">
                <em [ngClass]="isPublished(document) ? 'fa-check-circle' : 'fa-exclamation-circle'"
                    class="fa fa-light"></em>
                <span>{{ (isPublished(document) ? 'DOCUMENTS.published' : 'TEMPLATE.unpublished') | translate | uppercase }}</span>
              </div>
            </td>
            <td class="w" test-id="document-signature-status" *ngIf="!isESS && signatureEnabled">
              <ng-container *ngIf="getSignatureDisplayStatus(document.signatureStatus) as signatureStatus">
                <div [ngClass]="'status-signature-' + (signatureStatus | lowercase)"
                     class="status status-inline text-center">
                  <span>{{ 'DOCUMENTS.signature_status.' + signatureStatus | translate | uppercase }}</span>
                </div>
              </ng-container>
            </td>
            <td *ngIf="{opened: false} as contextMenu" class="w-50">
              <div (click-outside)="contextMenu.opened = false"
                   [class.open]="contextMenu.opened"
                   class="dropdown">
                <button (click)="contextMenu.opened = !contextMenu.opened"
                        class="btn btn-outline btn-xs btn-context-menu"
                        type="button">
                  <span class="fa fa-light fa-ellipsis-v"></span>
                </button>
                <ul #rowActionContextMenu
                    (click)="contextMenu.opened = false; $event.stopImmediatePropagation()"
                    *ngIf="contextMenu.opened"
                    class="dropdown-menu pull-right dropdown-menu-scale">
                  <li (click)="viewDocument(document, $event, contextMenu)" class="dropdown-item">
                    <i aria-hidden="true" class="fa fa-light fa-eye"></i>
                    <span>{{ 'DOCUMENTS.view_document' | translate }}</span>
                  </li>
                  <li (click)="download(document.id, $event, contextMenu)" class="dropdown-item">
                    <i aria-hidden="true" class="fa fa-light fa-download"></i>
                    <span>{{ 'DOCUMENTS.download_document' | translate }}</span>
                  </li>
                  <li (click)="openSendDocumentModal(document, $event, contextMenu)" class="dropdown-item"
                      *ngIf="!isESS && !readonly && !isPublished(document)">
                    <i aria-hidden="true" class="fa fa-light fa-thin fa-file-export"></i>
                    <span>{{ 'DOCUMENTS.publish_in_employee_space' | translate }}</span>
                  </li>
                  <li (click)="openSignatureFields(document, $event, contextMenu)"
                      class="dropdown-item" *ngIf="canConfigureSignatureFields(document)" test-id="configureSignatureFields">
                    <i aria-hidden="true" class="fa fa-light fa-signature"></i>
                    <span>{{ (document.signatureData?.signatureInfos?.length ? 'DOCUMENTS.edit_signature_fields' : 'DOCUMENTS.define_signature_fields') | translate }}</span>
                  </li>
                  <li (click)="openAskForSignatureModal(document, $event, contextMenu)"
                      class="dropdown-item"
                      *ngIf="!isESS && !readonly && hasSignatureRole && document.signatureStatus === SignatureStatusEnum.AVAILABLE">
                    <i aria-hidden="true" class="fa fa-light fa-signature"></i>
                    <span>{{ 'DOCUMENTS.send_for_signature' | translate }}</span>
                  </li>
                  <li (click)="checkSignatureStatus(document, $event, contextMenu)"
                      class="dropdown-item"
                      *ngIf="!isESS && !readonly && hasSignatureRole && document.signatureStatus === SignatureStatusEnum.SIGNATUREPENDING">
                    <i aria-hidden="true" class="fa fa-light fa-rotate"></i>
                    <span>{{ 'DOCUMENTS.check_signature' | translate }}</span>
                  </li>
                  <li (click)="deleteDocument(document.id, $event, contextMenu)"
                      *ngIf="document.status === 'INITIATED' && !isESS && !readonly"
                      class="dropdown-item text-danger">
                    <i aria-hidden="true" class="fa fa-light fa-trash"></i>
                    <span>{{ 'DOCUMENTS.delete_document' | translate }}</span>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <ng-container *ngIf="!loading && !documents?.length">
        <div test-id="not-found-message">
          <gp-illustrated-message [text]="'DOCUMENTS.documents_not_found'" [width]="'50%'"></gp-illustrated-message>
        </div>
      </ng-container>
    </div>
  </form>

  <gp-table-pagination
    (pageChange)="refreshDocuments()"
    [pagination]="pagination"
    [text]="'PAYMENT_REQUEST.showing___of_requests'">
  </gp-table-pagination>

</div>

<ng-container *ngIf="isMobile">
  <ul class="padding cards-container" *ngIf="!loading && documents?.length">
    <li class="card card-box box-shadow document-row"
        (click)="onDocumentSelect(document, $event)"
        [ngClass]="{'pointer': !readonly}"
        *ngFor="let document of documents; trackBy: trackByDocumentId">
      <div class="box-header">
        <h6 class="font-weight-bold max-width-80 wrap" [innerHTML]="document?.name | gpDisplayFile"></h6>
        <button type="button"
                class="btn btn-xs btn-icon white download fa fa-light fa-download"
                (click)="download(document.id, $event)">
        </button>
      </div>
      <div class="box-body">
        <ul class="list flex flex-wrap">
          <li class="list-item">
            <small class="text-muted _500">{{ 'TEMPLATE.templateName' | translate }}</small>
            <div
              class="list-body">{{ (document.family === UPLOADED_DOCUMENT ? 'DOCUMENTS.UPLOADED_DOCUMENT' : document?.family) | translate }}
            </div>
          </li>
          <li class="list-item">
            <small class="text-muted _500">{{ 'LEGAL_REPORTS.creationDate' | translate }}</small>
            <div class="list-body">{{ document.creationDate | gpDate }}</div>
          </li>
          <li class="list-item">
            <small class="text-muted _500">{{ 'TEMPLATE.created_by' | translate }}</small>
            <div class="list-body">{{ document?.tags?.creator }}</div>
          </li>

        </ul>
      </div>
    </li>
  </ul>
  <ng-container *ngIf="!loading && !documents?.length">
    <div test-id="not-found-message" class="m-t-md m-a-sm card card-box padding">
      <div class="box-body">
        <gp-illustrated-message [text]="'DOCUMENTS.documents_not_found'" [width]="'97%'"></gp-illustrated-message>
      </div>
    </div>
  </ng-container>
</ng-container>


<gp-view-document-side-panel
  *ngIf="showViewDocumentPanel"
  (close)="onCloseSidePanel()"
  (delete)="deleteDocument(selectedDocument.id)"
  [deletable]="selectedDocument.status === 'INITIATED' && !readonly"
  [confirmModalOpened]="confirmModalOpened"
  [currentFileName]="currentFileName"
  [error]="previewError"
  [noSupportedFormat]="noSupportedFormat"
  [loading]="loadingPreview"
  [preview]="reportDefinitionPreview"
></gp-view-document-side-panel>

<gp-modal #uploadDocumentPopup
          [closable]="true"
          class="upload-modal"
          gp-modal="upload-document">
  <div class="gp-modal-title">
    {{ 'DOCUMENTS.upload_document' | translate }}
  </div>
  <div class="gp-modal-body clearfix">
    <div class="col-md-12 form-group">
      <label><i aria-hidden="true" class="fa fa-light fa-info-circle"></i><span
        class="m-l-xs">{{ 'DOCUMENTS.file_format_pdf' | translate }}</span></label>
      <gp-upload-file
        #uploadFileComponent
        (isFileDeleted)="setFileForUpload(null)"
        (uploadedFile)="setFileForUpload($event)"
        [contentType]="'application/pdf'"
        [maxFileSize]="documentsOffering?.maxUploadSize"
        [minimalDisplay]="false"
      >
      </gp-upload-file>
    </div>
    <div class="col-md-12 form-group">
      <label>
        {{ 'DOCUMENTS.document_title' | translate }}
        <span class="text-primary">*</span>
      </label>
      <input [formControl]="documentTitleFormCtrl"
             [placeholder]="'DOCUMENTS.document_title' | translate"
             class="form-control"
             type="text">
    </div>
  </div>
  <div *ngIf="!saving" class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="uploadDocumentPopup.close()"
                class="btn btn-secondary p-x-md"
                type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
        <button (click)="saveDocument(uploadDocumentPopup)"
                [disabled]="!uploadIsValid"
                class="btn btn-dark p-x-md"
                type="button">
          {{ 'EMPLOYEE_FORM.submit' | translate }}
        </button>
      </div>
    </div>

  </div>
  <div *ngIf="saving" class="gp-modal-footer">
    <div class="pull-right">
      <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
    </div>
  </div>
</gp-modal>

<gp-modal #sendDocumentPopup
          [closable]="true"
          class="send-modal"
          gp-modal="send-document">
  <div class="gp-modal-title">
    {{ 'DOCUMENTS.publish_in_employee_space' | translate }}
  </div>
  <div [formGroup]="sendDocumentForm" class="gp-modal-body clearfix">
    <div class="col-md-12 form-group">
      <label for="receiver">
        {{ 'DOCUMENTS.receiver' | translate }}
        <span class="required">*</span>
      </label>
      <div>
        <gp-dropdown-select
          [attr.test-id]="'documentReceiver'"
          [customPlaceholderGenerator]="documentsService.placeholderForEmployee"
          [disabled]="true"
          buttonClasses="btn-xs"
          class="form-control no-b"
          formControlName="receiver"
          id="receiver"
          ngDefaultControl>
          <gp-dropdown-option *ngFor="let emp of [employee]" [ngValue]="emp">
            <div [innerHTML]="documentsService.placeholderForEmployee(emp)"></div>
          </gp-dropdown-option>
        </gp-dropdown-select>
      </div>
    </div>
    <div class="col-md-12 form-group">
      <label>
        {{ 'COMMON.comment' | translate }}
      </label>
      <textarea [placeholder]="'DOCUMENTS.document_comment_placeholder' | translate"
                [rows]="5" class="textarea-control"
                formControlName="comment">
      </textarea>
    </div>
    <div [formGroup]="emailForm" autocomplete="off" class="col-md-12 form-group">
      <div class="form-group checkbox">
        <input formControlName="sendEmail" id="send-email" type="checkbox"/>
        <label class="m-l-xs" for="send-email">{{ 'DOCUMENTS.send_email' | translate }}</label>
      </div>
      <div class="form-group" gpMvel [contractId]="selectedContract" [mvelAliases]="emailMvelAliases">
        <label for="email">
          {{ 'DOCUMENTS.email' | translate }}
          <span class="required">*</span>
        </label>
        <div>
          <input mvel-alias="personalEmail"
                 [attr.test-id]="'email'"
                 [placeholder]="'DOCUMENTS.email' | translate"
                 class="form-control"
                 formControlName="email"
                 id="email"
                 type="text"/>
        </div>
        <ul class="error-list"
            [attr.data-hidden]="emailForm.get('email').valid || !emailForm.get('email').dirty">
          <li *ngIf="emailForm.get('email').hasError('invalidEmailAddress')">
            {{ 'FORMS.VALIDATORS.invalid_email' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div *ngIf="!saving" class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="sendDocumentPopup.close()"
                class="btn btn-secondary p-x-md"
                type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
        <button (click)="sendDocument(sendDocumentPopup)"
                [disabled]="!sendDocumentForm.valid"
                class="btn btn-dark p-x-md"
                type="button">
          <i *ngIf="sendLoading" class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
          {{ 'DOCUMENTS.publish' | translate }}
        </button>
      </div>
    </div>

  </div>
  <div *ngIf="saving" class="gp-modal-footer">
    <div class="pull-right">
      <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
    </div>
  </div>
</gp-modal>
<gp-ask-for-signature-popup></gp-ask-for-signature-popup>
<gp-signature-fields (sendForSignature)="sendAfterSignatureFields($event)"></gp-signature-fields>
